<template>
<!-- eslint-disable -->
  <div class="indented">
    <form @submit.prevent="submitForm" ref="formHTML">
      <div class="form-horizontal">
        <h2>Delete Product</h2>
        <hr />
        <h4>Are you sure you want to delete this product?</h4>
        <div>
          <h5>{{ name }}</h5>

              <div class="form-group">
                <router-link style="text-decoration: none; color:inherit;" :to="{ path: '/DeleteProd', query: { Id: id } }">
                  <input type="submit" value="Delete" class="button btn btn-default" />
                </router-link>
              </div>
              <div class="form-group spaced">
                <a href="#" @click="goBack"><< Back</a>
              </div>
        </div>
      </div>
</form>
  </div>
</template>

<script>
  export default {
    name: 'Comp_DeleteProduct',
    props: ['id','name'],
    data() {
      return {

      }
    },
    methods: {
      goBack() {
        this.$router.push('/ShowProductsofCat');
      }
    }
  }
</script>

<style scoped src="bootstrap/dist/css/bootstrap.min.css">
  /* install bootstrap first by typing 'npm install bootstrap' in command prompt */
</style>

<style scoped>

  .indented {
    margin: 20px;
    max-width: 550px;
  }

  .button {
    border: 1px solid gray;
  }

  .spaced {
    margin-top: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/Comp_DeleteProduct.vue